export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/:path(.*)',
    name: '/[...path]',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/[...path].vue'),
    /* no children */
  },
  {
    path: '/account-paused',
    name: '/account-paused',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/account-paused.vue'),
    /* no children */
  },
  {
    path: '/accounts',
    /* internal name: '/accounts' */
    /* no component */
    children: [
      {
        path: ':master_account_id',
        name: '/accounts/[master_account_id]',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/accounts/[master_account_id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/action',
    /* internal name: '/action' */
    /* no component */
    children: [
      {
        path: '::flow_id',
        name: '/action/[:flow_id]',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/action/[:flow_id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/actions',
    name: '/actions',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/actions.vue'),
    /* no children */
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/MyTerritory',
    name: '/MyTerritory',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/MyTerritory.vue'),
    /* no children */
  },
  {
    path: '/preferences',
    /* internal name: '/preferences' */
    /* no component */
    children: [
      {
        path: 'email',
        name: '/preferences/email',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/preferences/email.vue'),
        /* no children */
      },
      {
        path: 'integrations',
        name: '/preferences/integrations',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/preferences/integrations.vue'),
        /* no children */
      },
      {
        path: 'qualificationsignals',
        name: '/preferences/qualificationsignals',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/preferences/qualificationsignals.vue'),
        /* no children */
      },
      {
        path: 'titles',
        name: '/preferences/titles',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/preferences/titles.vue'),
        /* no children */
      },
      {
        path: 'user',
        name: '/preferences/user',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/preferences/user.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/reporting',
    name: '/reporting',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/reporting.vue'),
    /* no children */
  },
  {
    path: '/settings',
    name: '/settings',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/settings.vue'),
    /* no children */
  },
  {
    path: '/support-impersonation',
    name: '/support-impersonation',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/support-impersonation.vue'),
    /* no children */
  },
  {
    path: '/upload',
    name: '/upload',
    component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/upload.vue'),
    /* no children */
  },
  {
    path: '/valueMatch',
    /* internal name: '/valueMatch' */
    /* no component */
    children: [
      {
        path: ':master_account_id',
        name: '/valueMatch/[master_account_id]',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/valueMatch/[master_account_id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/workspaces',
    /* internal name: '/workspaces' */
    /* no component */
    children: [
      {
        path: '::workspace_id',
        name: '/workspaces/[:workspace_id]',
        component: () => import('/Users/leerodgers/workspace/code/syft_next/src/pages/workspaces/[:workspace_id].vue'),
        /* no children */
      }
    ],
  }
]
